<template>
	<div v-touch:swipe.left="nextImage" v-touch:swipe.right="prevImage" ref="iSlider" class="relative w-full h-full">
		<!-- Slides -->
		<div class="flex w-full overflow-hidden">
			<div
				class="iSliderItem min-w-full max-h-full transition-transform duration-300"
				v-for="(image, index) in images"
				:key="index"
			>
				<img
					:class="['w-full object-cover', `h-[${sliderHeight}px]`]"
					:src="image"
					loading="lazy"
					:alt="`slide image ${index + 1}`"
					@error="$emit('onError')"
				/>
			</div>
		</div>
		<!-- Controls -->
		<div v-if="images.length > 1" class="absolute flex flex-col inset-4">
			<div class="invisible md:visible flex justify-between items-center flex-1">
				<div
					@click="prevImage"
					class="w-10 h-10 rounded-full text-dj-gray-dark bg-white/30 hover:bg-white border border-dj-gray transition-colors grid place-content-center cursor-pointer"
				>
					<BaseIcon icon="ic:round-arrow-back" class="text-3xl" color="currentColor" />
				</div>
				<div
					@click="nextImage"
					class="w-10 h-10 rounded-full text-dj-gray-dark bg-white/30 hover:bg-white border border-dj-gray transition-colors grid place-content-center cursor-pointer"
				>
					<BaseIcon icon="ic:round-arrow-forward" class="text-3xl" color="currentColor" />
				</div>
			</div>
			<div class="flex items-center">
				<span class="ml-auto md:ml-2 mr-2 text-white text-xs md:text-base text-shadow-xl">
					{{ currentSlide + 1 }} / {{ images.length }}
				</span>
				<BaseIcon class="text-lg md:text-2xl drop-shadow-xl" icon="ic:round-image" color="white" />
			</div>
		</div>
	</div>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";

export default defineComponent({
	name: "ImageSlider",
	props: {
		images: {
			type: Array as PropType<string[]>,
			required: true,
		},
		autoSlides: {
			type: Boolean,
			default: false,
		},
	},
	emits: ["onError"],
	setup(props) {
		const iSlider = ref<HTMLElement>(null);
		const currentSlide = ref(0);
		const sliderHeight = ref(0);
		const interval = ref<NodeJS.Timer>(null);

		onMounted(() => {
			if (props.autoSlides && props.images.length > 1) {
				interval.value = setInterval(() => {
					nextImage();
				}, 4000);
			}
			sliderHeight.value = iSlider.value.getBoundingClientRect().height;
		});

		onUpdated(() => {
			sliderHeight.value = iSlider.value.getBoundingClientRect().height;
		});

		onUnmounted(() => {
			clearInterval(interval.value);
		});

		function nextImage() {
			if (props.images.length > 0) {
				currentSlide.value + 1 < props.images.length ? (currentSlide.value += 1) : (currentSlide.value = 0);
				const slides = Array.from(document.querySelectorAll(".iSliderItem"));
				slides.forEach((slide) => {
					(slide as HTMLElement).style.transform = `translateX(-${currentSlide.value * 100}%)`;
				});
			}
		}

		function prevImage() {
			if (props.images.length > 0) {
				currentSlide.value - 1 >= 0
					? (currentSlide.value -= 1)
					: (currentSlide.value = props.images.length - 1);
				const slides = Array.from(document.querySelectorAll(".iSliderItem"));
				slides.forEach((slide) => {
					(slide as HTMLElement).style.transform = `translateX(-${currentSlide.value * 100}%)`;
				});
			}
		}

		return {
			iSlider,
			sliderHeight,
			nextImage,
			prevImage,
			currentSlide,
		};
	},
});
</script>
